import React, { memo } from 'react';
import cn from 'classnames';

import { useTranslation } from 'providers/GILT.provider';

import CN from './TagDescription.module.scss';

const TagDescription = ({ onChange, description, darkTheme }) => {
  const { t } = useTranslation();

  return (
    <div data-bem="TagDescription" className={cn({ [CN.tagDescription]: true, [CN.dark]: darkTheme })}>
      <span>{t('clientTags.description')}</span>
      <input
        name="description"
        id="description"
        className={CN.inputDefault}
        type="text"
        onChange={onChange}
        value={description}
        placeholder=""
        maxLength="200"
      />
    </div>
  );
};

export default memo(TagDescription);
